/**
 * Navigation Module
 * Handles navigation behavior including scroll effects and mobile menu
 */

let lastScrollPosition = 0;
let ticking = false;

/**
 * Initialize navigation features
 */
export const initNavigation = () => {
    const secondaryMenu = document.querySelector('#secondaryMenu');

    if (!secondaryMenu) return;

    // Add scroll listener with throttling for performance
    window.addEventListener('scroll', () => {
        lastScrollPosition = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateNavigationOnScroll(secondaryMenu, lastScrollPosition);
                ticking = false;
            });

            ticking = true;
        }
    });

    // Highlight active menu item based on scroll position
    initActiveMenuHighlight();

    // Initialize dropdown menus
    initDropdowns();
};

/**
 * Update navigation appearance based on scroll position
 */
const updateNavigationOnScroll = (menu, scrollPosition) => {
    if (scrollPosition > 50) {
        menu.classList.add('scrolled');
    } else {
        menu.classList.remove('scrolled');
    }
};

/**
 * Highlight active menu item based on current section
 */
const initActiveMenuHighlight = () => {
    const sections = document.querySelectorAll('section[id]');
    const navLinks = document.querySelectorAll('#secondaryMenu .nav-link');

    if (sections.length === 0 || navLinks.length === 0) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const id = entry.target.getAttribute('id');

                    // Remove active class from all nav items
                    navLinks.forEach((link) => {
                        const parent = link.closest('.nav-item');
                        if (parent) {
                            parent.classList.remove('active');
                        }
                    });

                    // Add active class to current nav item
                    const activeLink = document.querySelector(`#secondaryMenu .nav-link[href="#${id}"]`);
                    if (activeLink) {
                        const parent = activeLink.closest('.nav-item');
                        if (parent) {
                            parent.classList.add('active');
                        }
                    }
                }
            });
        },
        {
            threshold: 0.3,
            rootMargin: '-100px 0px -50% 0px'
        }
    );

    sections.forEach((section) => observer.observe(section));
};

/**
 * Initialize dropdown menu functionality
 * Handles click events for mobile dropdown toggles
 */
const initDropdowns = () => {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            // On mobile/tablet, prevent default navigation and toggle dropdown
            const isMobile = window.innerWidth < 992; // $breakpoint-lg

            if (isMobile) {
                e.preventDefault();
                const dropdown = toggle.closest('.dropdown');

                if (dropdown) {
                    // Close all other dropdowns
                    document.querySelectorAll('.dropdown.show').forEach((openDropdown) => {
                        if (openDropdown !== dropdown) {
                            openDropdown.classList.remove('show');
                        }
                    });

                    // Toggle current dropdown
                    dropdown.classList.toggle('show');
                }
            }
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
        const isMobile = window.innerWidth < 992;

        if (isMobile && !e.target.closest('.dropdown')) {
            document.querySelectorAll('.dropdown.show').forEach((dropdown) => {
                dropdown.classList.remove('show');
            });
        }
    });

    // Close dropdowns when window is resized to desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 992) {
            document.querySelectorAll('.dropdown.show').forEach((dropdown) => {
                dropdown.classList.remove('show');
            });
        }
    });
};
